import axios from '@/plugins/axios'

/**
 * Force refresh PixelMetrics
 */
const forceRefreshPixelMetrics = async ({
  // eslint-disable-next-line camelcase
  advertiser_id = null,
  // eslint-disable-next-line camelcase
  company_id = null
}) => {
  try {
    const params = {}
    // eslint-disable-next-line camelcase
    if (advertiser_id) params.advertiser_id = advertiser_id
    // eslint-disable-next-line camelcase
    if (company_id) params.company_id = company_id

    const response = await axios.get('v1/pixelmetrics', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  forceRefreshPixelMetrics
}
